import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type AlertState = {
  isOpen: boolean
  text: string
  type: "success" | "info" | "warning" | "error" | undefined
}

const initialState: AlertState = {
  isOpen: false,
  text: "",
  type: undefined,
}

export const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert: (
      state,
      action: PayloadAction<{
        text: string
        type: "success" | "info" | "warning" | "error" | undefined
      }>,
    ) => {
      ;(state.isOpen = true), (state.text = action.payload.text)
      state.type = action.payload.type
    },
    hideAlert: (state) => {
      state.isOpen = false
      state.text = ""
      state.type = undefined
    },
  },
})

export const { showAlert, hideAlert } = alertSlice.actions

export default alertSlice.reducer
